function cov_14pi9xln8b() {
  var path = "/app/src/components/currency/currency.tsx";
  var hash = "73be68919a7444c48b90fceb08b97c5d3fab3668";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/currency/currency.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 12
        },
        end: {
          line: 9,
          column: 23
        }
      },
      "2": {
        start: {
          line: 11,
          column: 58
        },
        end: {
          line: 17,
          column: 3
        }
      },
      "3": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "4": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 78
        }
      },
      "5": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 79
        }
      },
      "6": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 48
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 25
          }
        },
        loc: {
          start: {
            line: 8,
            column: 70
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 21,
            column: 78
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 23,
            column: 79
          }
        }, {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 25,
            column: 48
          }
        }],
        line: 19
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "73be68919a7444c48b90fceb08b97c5d3fab3668"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_14pi9xln8b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_14pi9xln8b();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Icon } from 'src/components/icon';
import { useLocale } from 'src/hooks/use-locale';
import { CurrencyType } from 'src/types/currency';
import styles from './styles.css';
cov_14pi9xln8b().s[0]++;
export var Currency = function Currency(_ref) {
  var currency = _ref.currency;
  cov_14pi9xln8b().f[0]++;
  var t = (cov_14pi9xln8b().s[1]++, useLocale());
  var currencyTranslate = (cov_14pi9xln8b().s[2]++, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CurrencyType.AED, t('AED')), CurrencyType.KWD, t('KWD')), CurrencyType.SAR, t('SAR')), CurrencyType.BHD, t('BHD')), CurrencyType.QAR, t('QAR')));
  cov_14pi9xln8b().s[3]++;
  switch (true) {
    case currency === CurrencyType.SAR:
      cov_14pi9xln8b().b[0][0]++;
      cov_14pi9xln8b().s[4]++;
      return /*#__PURE__*/React.createElement(Icon, {
        name: "riyal",
        svgAttributes: {
          className: styles.icon
        }
      });
    case currency === CurrencyType.AED:
      cov_14pi9xln8b().b[0][1]++;
      cov_14pi9xln8b().s[5]++;
      return /*#__PURE__*/React.createElement(Icon, {
        name: "dirham",
        svgAttributes: {
          className: styles.icon
        }
      });
    default:
      cov_14pi9xln8b().b[0][2]++;
      cov_14pi9xln8b().s[6]++;
      return /*#__PURE__*/React.createElement(React.Fragment, null, currencyTranslate[currency]);
  }
};